import idx from 'idx'

import { DETAIL_USER_GROUP_ADD_FULFILLED, DETAIL_USER_GROUP_REMOVE_FULFILLED } from 'Modules/UserDetailModule/actionTypes'
import { SIGN_OUT } from 'Global/Stores/auth'

const GROUP_DELETE = 'API|GROUP/DELETE'
export const GROUP_DELETE_FULFILLED = `FULFILLED_${GROUP_DELETE}`

const GROUP_GET = 'API|GROUP/GET'
const GROUP_GET_FULFILLED = `FULFILLED_${GROUP_GET}`
const GROUP_GET_PENDING = `PENDING_${GROUP_GET}`
const GROUP_GET_REJECTED = `REJECTED_${GROUP_GET}`

const GROUP_RESET = 'GROUP/RESET'

const GROUP_SET_NAME = 'API|GROUP/GROUP_SET_NAME'
export const GROUP_SET_NAME_FULFILLED = `FULFILLED_${GROUP_SET_NAME}`

const GROUP_SET_PERMISSIONS = 'API|GROUP/GROUP_SET_PERMISSIONS'
export const GROUP_SET_PERMISSIONS_FULFILLED = `FULFILLED_${GROUP_SET_PERMISSIONS}`

export const groupReset = () => {
  return { type: GROUP_RESET }
}

export const groupDelete = id => {
  return {
    payload: {
      confirmationMessage: 'Are you sure you want to delete this group? This action cannot be undone.',
    },
    meta: { data: { id }, method: 'DELETE', url: `/api/v1/groups` },
    type: GROUP_DELETE,
  }
}

export const groupGet = id => {
  return {
    meta: { url: `/api/v1/groups/${id}` },
    type: GROUP_GET,
  }
}

export const groupSetName = (id, name) => ({
  payload: {
    confirmationMessage: `Are you sure you want to update the group's name?`,
  },
  meta: {
    data: { id, name },
    method: 'post',
    errorMessage: `Error setting new name. Please try again.`,
    successMessage: `New name set.`,
    url: '/api/v1/groups/setName',
  },
  type: GROUP_SET_NAME,
})

export const groupSetPermissions = (id, permissions) => ({
  payload: {
    confirmationMessage: `Are you sure you want to update the group's permissions?`,
  },
  meta: {
    data: { id, permissions },
    method: 'post',
    errorMessage: `Error setting new permissions. Please try again.`,
    successMessage: `New permissions set.`,
    url: '/api/v1/groups/setPermissions',
  },
  type: GROUP_SET_PERMISSIONS,
})

const initialState = {
  data: {},
  done: false,
  error: false,
  pending: true,
  wasDeleted: false,
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case GROUP_DELETE_FULFILLED:
      return {
        ...state,
        data: {},
        done: false,
        wasDeleted: true,
      }

    case GROUP_GET_FULFILLED:
      return {
        ...state,
        data: payload.data,
        done: true,
        error: false,
        pending: false,
      }

    case GROUP_GET_PENDING:
      return {
        ...state,
        done: false,
        error: false,
        pending: true,
      }

    case GROUP_GET_REJECTED:
      return {
        ...state,
        done: true,
        error: true,
        pending: false,
      }

    case GROUP_RESET:
      return initialState

    case GROUP_SET_NAME_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          name: payload.data.name,
        },
      }

    case GROUP_SET_PERMISSIONS_FULFILLED:
      return {
        ...state,
        data: {
          ...state.data,
          permissions: payload.data.permissions,
        },
      }

    // External

    case DETAIL_USER_GROUP_ADD_FULFILLED:
      if (payload.data.addedGroup !== idx(state, _ => _.data.id)) {
        return state
      }

      return {
        ...state,
        data: {
          ...state.data,
          users: [...state.data.users, payload.data],
        },
      }

    case DETAIL_USER_GROUP_REMOVE_FULFILLED:
      if (payload.data.removedGroup !== idx(state, _ => _.data.id)) {
        return state
      }

      return {
        ...state,
        data: {
          ...state.data,
          users: state.data.users.filter(user => user.id !== payload.data.id),
        },
      }

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
